// extracted by mini-css-extract-plugin
export default {"rightColumn":"rightColumn_rightColumn__XzZev"};